import { render, staticRenderFns } from "./PurchaseInvoiceView.vue?vue&type=template&id=5d992ec5"
import script from "./PurchaseInvoiceView.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports